import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  mobileHeaders: {
    marginTop: "5px",
    fontSize: "12px",
    color: "#9A9A9A",
    textAlign: "center",
  },
}))

export default styles
